module.exports = __webpack_public_path__ + "img/activity_checkin.2147b77f.png";